import type { ReactNode } from 'react';

export const symbol_bottom_app_bar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-203v143h600v-143H548q-14 14-31.16 22-17.17 8-37 8-19.84 0-36.84-8-17-8-31-22H180Zm321-39q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm-321-21h210q0-36 27-63t63-27q36 0 63 27t27 63h210v-397H180v397Zm0 203h600-600Z"
		/>
	</svg>
);
